import React, { useEffect, useState } from 'react'
import { UserContextProvider } from '../context/UserContext'
import Layout from '../components/Layout'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import PertandinganForm from '../sections/PertandinganForm'
import { AxiosError } from 'axios'
import { getDetailMatches, updateMatches } from '../services/match.service'
import { LIGA_SATU_CLUB } from '../constants/dummy'

const EditPertandingan = () => {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const params = useParams()

  const onSubmit = async (e) => {
    try {
      setIsLoading(true)
      e.preventDefault()
      const data = new FormData(e.target)
      data.set(
        'teamLeftLogo',
        LIGA_SATU_CLUB.find(
          (a) => a.name === data.get('teamLeftName').toString(),
        )?.icon,
      )
      data.set(
        'teamRightLogo',
        LIGA_SATU_CLUB.find(
          (a) => a.name === data.get('teamRightName').toString(),
        )?.icon,
      )
      await updateMatches({ id: params?.id, form: data })
      toast.success('Berhasil mengupdate pertandingan')
      navigate('/konten/pertandingan')
    } catch (error) {
      toast.error(error?.response?.data?.error?.message ?? 'Error')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const fetch = async () => {
      try {
        setIsLoading(true)
        const data = await getDetailMatches({ id: params?.id })
        setData(data?.data ?? null)
      } catch (error) {
        let message = "There's something wrong. Please try again later."
        if (error instanceof AxiosError) {
          message =
            error.response.data?.error?.message ??
            "There's something wrong. Please try again later."
        }
        toast.error(message, {
          toastId: message,
        })
      } finally {
        setIsLoading(false)
      }
    }
    fetch()
  }, [])

  if (data === null || isLoading) {
    return <></>
  }

  return (
    <UserContextProvider>
      <Layout
        activeNav="Pertandingan"
        isBackButtonShown={true}
        isDetailShown={true}
        detail={data}
        isPreviewShown={true}
        previewComponent={
          <div>
            <p className="font-semibold text-[28px] my-4">Preview</p>
            <img
              src="https://nos.wjv-1.neo.id/jakmania-bucket/assets/Tutor%20CMS/Match/Match-x3.png"
              className="object-contain mx-auto w-[210px] h-[480px] mb-4"
            />
            <p className="font-normal text-[16px]">Deskripsi</p>
            <p className="opacity-70 text-[14px] mb-4">
              Perubahan pada pertandingan akan mempengaruhi bagian pertandingan
              di beranda, data yang kamu upload nanti akan masuk ke aplikasi the
              Jakmania.
            </p>
          </div>
        }
      >
        <PertandinganForm
          onSubmit={onSubmit}
          data={data}
          isLoading={isLoading}
        />
      </Layout>
    </UserContextProvider>
  )
}

export default EditPertandingan
